module.exports = __webpack_public_path__ + "static/media/map-marker-exclamation.3dacd190.svg";